import React from "react";
import WorkDetailsComponent from "../components/WorkDetailsComponent";
import LetsWork from "../components/LetsWorkTogether";

const WorkDetails = (props) => {
  return (
    <>
      <WorkDetailsComponent />
      <LetsWork />
    </>
  );
};

export default WorkDetails;
